module.exports = __webpack_public_path__ + "static/media/home_item_02.d6078529.png";